// extracted by mini-css-extract-plugin
module.exports = {"center":"ptmralXl","graphic":"xHDUOwvn"};